import { useTranslation } from "react-i18next";
import { Paper, Stack, Title, useMantineTheme } from "@mantine/core";
import { CampaignInquiryQueryDataType } from "src/hooks/campaignInquiries";

import { CampaignInquiryAdditionalNotes } from "./additionalNotes";
import { CampaignInquiryDelivery } from "./delivery";
import { CampaignInquiryGeneral } from "./general";
import { CampaignInquiryOutcome } from "./outcome";
import { CampaignInquiryPricing } from "./pricing";
import { CampaignInquiryProducts } from "./products";
import { CampaignInquiryQuestionnaire } from "./questionnaire";

export interface AssignmentTabProps {
    campaignInquiry: CampaignInquiryQueryDataType;
}

export const AssignmentTab = ({ campaignInquiry }: AssignmentTabProps) => {
    const { t } = useTranslation(["common"]);
    const theme = useMantineTheme();

    return (
        <Stack>
            <Paper p="xl" radius="md" ml={`calc(24px + ${theme.spacing.sm})`} withBorder>
                <CampaignInquiryGeneral campaignInquiry={campaignInquiry} />
            </Paper>
            <Paper p="xl" radius="md" ml={`calc(24px + ${theme.spacing.sm})`} withBorder>
                <Title mb="md" order={3}>
                    {t("campaign_products")}
                </Title>
                <CampaignInquiryProducts campaignInquiry={campaignInquiry} />
            </Paper>
            <Paper p="xl" radius="md" ml={`calc(24px + ${theme.spacing.sm})`} withBorder>
                <Title mb="md" order={3}>
                    {t("campaign_delivery")}
                </Title>
                <CampaignInquiryDelivery campaignInquiry={campaignInquiry} />
            </Paper>
            <Paper p="xl" radius="md" ml={`calc(24px + ${theme.spacing.sm})`} withBorder>
                <Title mb="md" order={3}>
                    {t("campaign_pricing")}
                </Title>
                <CampaignInquiryPricing campaignInquiry={campaignInquiry} />
            </Paper>
            <Paper p="xl" radius="md" ml={`calc(24px + ${theme.spacing.sm})`} withBorder>
                <Title mb="md" order={3}>
                    {t("campaign_outcome")}
                </Title>
                <CampaignInquiryOutcome campaignInquiry={campaignInquiry} />
            </Paper>
            <Paper p="xl" radius="md" ml={`calc(24px + ${theme.spacing.sm})`} withBorder>
                <Title mb="md" order={3}>
                    {t("campaign_questionnaire")}
                </Title>
                <CampaignInquiryQuestionnaire campaignInquiry={campaignInquiry} />
            </Paper>
            <Paper p="xl" radius="md" ml={`calc(24px + ${theme.spacing.sm})`} withBorder>
                <Title mb="md" order={3}>
                    {t("campaigninquiry_additionalnotes")}
                </Title>
                <CampaignInquiryAdditionalNotes campaignInquiry={campaignInquiry} />
            </Paper>
        </Stack>
    );
};
